export default {
  namespaced: true,
  state: () => ({
    isMobile: false,
  }),
  mutations: {
    SET_IS_MOBILE(state, value) {
      state.isMobile = value;
    }
  },
  actions: {
    checkDevice({ commit }) {
      if (typeof window !== 'undefined') {
        commit('SET_IS_MOBILE', window.innerWidth <= 768);
      }
    }
  },
  getters: {
    isMobile: (state) => state.isMobile,
  }
}
